<template>
  <div class="app-container">
    <BjPage
      ref="BjPage"
      :query-params="queryParams"
      :col-span="colSpan"
      :get-action="queryApi"
      :serial="serial"
      :selection="selection"
      :before-reset-search="beforeResetSearch"
      @handleSelectionChange="handleSelectionChange"
      @showSetting="SortableTable.show"
      @header-dragend="SortableTable.handleHeaderDragend"
      @header-contextmenu="SortableTable.handleHeaderContextmenu"
    >
      <template v-slot:baseForm>
        <el-col v-if="!$store.getters.cusId" :span="colSpan">
          <el-form-item :label="$t('billingPage.CustomerName')">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item label="SKU">
            <BjInputCode
              v-model="queryParams.skuCode"
              placeholder="SKU"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessAfterCsgReturn.main.outRefundNo')">
            <BjInputCode v-model="queryParams.outRefundNo" :placeholder="$t('BusinessAfterCsgReturn.main.outRefundNo')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('BusinessPurchaseOrderDetail.table.associatedCode')">
            <BjInputCode v-model="queryParams.thirdCode" :placeholder="$t('BusinessPurchaseOrderDetail.table.associatedCode')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('table.createTimeText')">
            <BjDateRangePicker v-model="queryParamsTime_pay" :placeholder="$t('table.createTimeText')" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('fileSearch.table.UpdateTime')">
            <BjDateRangePicker v-model="queryParamsUpdateTime_pay" :placeholder="$t('fileSearch.table.UpdateTime')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <div>
          <el-col>
            <el-button
              v-if="!$store.getters.cusId"
              v-permission:BusinessAfterCsgAdminReturnAdd
              type="primary"
              class="main-btn"
              @click="onAdd"
              >{{ $t('addText') }}</el-button
            >
          </el-col>
        </div>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column
            v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'"
          >
            <template v-slot="{ row }">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(row.cusId) }}</template>
              <template v-else-if="col.prop === 'outRefundNo'">
                <span class="link" @click="onDetail(row)">{{ row[col.prop] }}</span>
                <BjCopyIcon :copy="row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'creationDate'">{{ row[col.prop] | timeOperateTwoHour }}</template>
              <template v-else-if="col.prop === 'lastUpdateDate'">{{ row[col.prop] | timeOperateTwoHour }}</template>

              <template v-else-if="col.prop === 'status'">{{
                $t(RETURN_ORDER_STATUS.bjGet(row[col.prop]))
              }}</template>
              <span v-else>{{ row[col.prop] | timeFilters(row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="col.prop === 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || 'right'"
            align="center"
          >
            <template v-slot="{ row }">
                <el-button v-permission:BusinessAfterCsgAdminReturnView type="text" class="view-btn" @click="onDetail(row)">{{ $t('BusinessPurchaseOrderList.View') }}</el-button>
                <el-button v-if="!OperationBtn.includes(row.status) && !$store.getters.cusId" v-permission:BusinessAfterCsgAdminReturnEdit type="text" @click="onEdit(row)">{{ $t('editText') }}</el-button>
                <el-button v-if="!OperationBtn.includes(row.status) && !$store.getters.cusId" type="text" @click="onAbandon(row)">{{ $t('BusinessPurchaseOrderList.Abandoned') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { thirdReturnApi } from '@/api';
import { RETURN_ORDER_STATUS } from '@/utils/constants';
import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';

export default {
  name: 'BusinessAfterCsgAdminReturnIndex',
  components: {
    BjSelectCustomer
  },
  mixins: [pageMiXin],
  data() {
    return {
      RETURN_ORDER_STATUS,
      colSpan: 4,
      selection: false,
      queryApi: thirdReturnApi.getThirdOrderCanReturnGoods,
      // 查询参数
      queryParamsTime_pay: [],
      queryParamsUpdateTime_pay: [],
      queryParams: {
        skuCode: null,
        outRefundNo: null,
        createStartTime: null,
        createEndTime: null,
        lastUpdateStartTime: null,
        lastUpdateEndTime: null,
        cusId: null,
        thirdCode: null
      },
      // 表单校验
      rules: {},
      OperationBtn: ['Abandoned', 'BackInventory'],
      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100' },
        { label: this.$t('BusinessAfterCsgReturn.main.outRefundNo'), prop: 'outRefundNo', isCheck: true, disabled: false, width: '170' },
        { label: this.$t('BusinessPurchaseOrderDetail.table.associatedCode'), prop: 'thirdCode', isCheck: true, disabled: false, width: '170' },
        { label: 'SKU', prop: 'standardSkuCode', isCheck: true, disabled: false, width: '170' },
        { label: this.$t('goodsSku.detail.qty'), prop: 'planQty', isCheck: true, disabled: false, width: '150' },
        { label: this.$t('table.createTimeText'), prop: 'creationDate', isCheck: true, disabled: false },
        { label: this.$t('fileSearch.table.UpdateTime'), prop: 'lastUpdateDate', isCheck: true, disabled: false },
        { label: this.$t('businessLogisticsCompany.common.status'), prop: 'status', isCheck: true, disabled: false, width: '150' },
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 190 },
      ],
    };
  },
  computed: {
    labelList() {
        return this.$store.getters.cusId ? this.labelList1.filter(item => item.prop != 'cusId') : this.labelList1;
      },
  },
  watch: {
    queryParamsTime_pay(v) {
      this.queryParams.createStartTime = (v || [])[0];
      this.queryParams.createEndTime = (v || [])[1];
    },
    queryParamsUpdateTime_pay(v) {
      this.queryParams.lastUpdateStartTime = (v || [])[0];
      this.queryParams.lastUpdateEndTime = (v || [])[1];
    }
  },
  mounted() {
    this.queryParams.cusId = this.$store.getters.cusId ? this.$store.getters.cusId : null;
  },
  methods: {

    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_pay = null;
      this.queryParamsUpdateTime_pay = null;
      this.queryParams.skuCode = null;
      this.queryParams.outRefundNo = null;
      this.queryParams.cusId = null;
      this.queryParams.thirdCode = null;
      return new Promise(resolve => {
        resolve();
      });
    },
    /** 新建退货单 */
    onAdd() {
      this.$toPage('BusinessAfterCsgAdminReturnAdd');
    },
    // 编辑
    onEdit(row) {
      const { id } = row;
      this.$toPage('BusinessAfterCsgAdminReturnEdit', { id });
    },
    // 查看
    onDetail(row) {
      const { id } = row;
      this.$toPage('BusinessAfterCsgAdminReturnView', { id });
    },
    // 作废
    onAbandon(row) {
      this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
        const API_DATA = row;
        delete API_DATA.createdBy;
        delete API_DATA.lastUpdatedBy;
        API_DATA.status = 'Abandoned';
        thirdReturnApi.editThirdPartyReturnOrder(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.refresh();
            }, 500);
          }
      });
      }
      ).catch(_ => {});
    }
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
